<template>
    <div class="customer">
        <div class="layout-page-box">
            <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
                <el-form-item label="创建时间">
                    <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="客户卡号" label-width="130px">
                    <el-input v-model.trim="filters.ctmCode" clearable placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="客户姓名" label-width="130px">
                    <el-input v-model.trim="filters.ctmName" clearable placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="客户手机号" label-width="130px">
                    <el-input v-model.trim="filters.ctmMobile" clearable placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search" size="small">查询</el-button>
                </el-form-item>
            </el-form>
            <div class="buttonText">
                <!-- <div class="delete" @click="delAll">删除客户</div> -->
                <!-- <div class="addData" @click="add">新增客户</div> -->
                <el-button type="warning" @click="mergeChange">合并客户</el-button>
                <el-button type="warning" @click="consume">划扣</el-button>
                <el-button type="warning" @click="billing">购买</el-button>
            </div>
        </div>
        <div class="all">
            <div class="left">
                <el-table v-loading="loading" ref="table" :row-key="getRowKeys" highlight-current-row @row-click="currentChange" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}">
                    <el-table-column type="selection" :reserve-selection="true"></el-table-column>
                    <el-table-column sortable prop="ctmId" label="编号" align="center"></el-table-column>
                    <el-table-column sortable prop="ctmName" label="姓名"></el-table-column>
                    <el-table-column sortable prop="ctmCode" label="卡号"></el-table-column>
                    <el-table-column prop="ctmMobile" width="120" label="电话">
                        <template slot="header">
                            <span>联系方式</span>
                            <el-button style="margin-left:5px;" v-permission="'90'" @click="show" class="filter-item" type="success" size="mini" icon="el-icon-view"></el-button>
                        </template>
                        <template slot-scope="scope">
                            <span v-if="mobileHiding==true">{{scope.row.ctmMobile}}</span>
                            <span v-if="mobileHiding==false">
                                <div v-for="(item,index) in scope.row.ctmMobile.split('/')" :key='index'>{{item.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2")}}</div>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column sortable prop="ctmSex" label="性别"></el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total,prev, pager, next" :total="filters.pagination.total">
                </el-pagination>
            </div>
            <div v-if="flag" class="page-right">
                <!-- 客户基本信息 -->
                <userTop :userinfo='userinfo'></userTop>
                <!-- 账户统计信息 -->
                <!-- <customTable :userstatic="userstatic"></customTable> -->
                <customTab :key="datekey" :userCode="userCode"></customTab>
            </div>
        </div>
        <!-- 合并客户弹框 -->
        <el-dialog v-if="dialogMerge" :visible.sync="dialogMerge" center class="dialogItem" :close-on-click-modal="false" title="合并客户">
            <add @close="close" :mergeData="mergeData" @add-comment="appendComment" @changeSelection="changeSelection"></add>
        </el-dialog>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import userTop from './userTop.vue'
import customTable from './customTable.vue'
import customTab from './customTab.vue'
import add from './add.vue'
import permission from '../../../directives/permission/index'
export default {
    directives: {
        permission
    },
    computed: {
        ...mapGetters(["areaAndFloorList",]),
    },
    components: { userTop, customTable, customTab, add },
    name: "customer",
    data() {
        return {
            filters: {
                types: '',
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
                startTime: '',
                endTime: '',
                outpatientService: '',
            },
            tableData: [],
            multipleSelection: [],
            dialogFormVisible: false,
            dialogMerge: false,
            formData: {},
            mergeData: [],
            tableHeight: "",
            isId: '',
            userinfo: {},
            // userstatic: {
            //     value1: 4154.564,
            //     value2: 2222,
            //     title: '今年的增长'
            // },
            userCode: '',
            datekey: '',
            flag: true,
            mobileHiding: false,
            loading: true,
            ccData: []
        }
    },
    created() {
        this.tableHeight = document.documentElement.clientHeight - 250
    },
    mounted() {
        this.query(this.filters.pagination.page);
    },
    watch: {
        $route(to, from) {
            if (this.activatedFlag) {
                this.query(this.filters.pagination.page);
            }
        },
    },
    methods: {
        show() {
            this.mobileHiding = !this.mobileHiding
        },
        getRowKeys(row) {
            return row.ctmId
        },
        close() {
            this.dialogMerge = false
        },
        appendComment(item) {
            this.query(this.filters.pagination.page);
        },
        search() {
            this.filters.pagination.page = 1
            this.loading = true
            this.refresh()
            this.$refs.table.setCurrentRow();
            this.userinfo = {
                codeName: 1
            }
            this.userCode = ''
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pageChanged(page) {
            this.filters.pagination.page = page
            this.loading = true
            this.refresh()
        },
        handleSizeChange(sizes) {
            this.filters.pagination.limit = sizes
            this.loading = true
            this.refresh()
        },
        refresh() {
            router.push({
                path: this.$route.path,
                query: _.merge({}, this.$route.query, {
                    __query: JSON.stringify(this.pagination)
                }, {
                        random: Math.random()
                    })
            })
        },
        // 新增项目
        add() {
            this.dialogFormVisible = true
            this.isId = ''
            // 新增置空
            this.formData = {
                projectName: "",
                projectCategory: "",
                project: "",
                outpatientService: '',
                sknDiagnosisMenuList: [{
                    diagnosisName: '',
                    correspondingName: '',
                }],

            }
        },
        // 合并客户
        mergeChange() {
            this.mergeData = this.multipleSelection
            if (this.multipleSelection.length == 0) {
                _g.toast("error", '请先选择要合并的客户');
                return;
            }
            this.dialogMerge = true
        },
        changeSelection(val) {
            this.$refs.table.clearSelection()
        },
        getEarId(item) {
            let arr = this.areaAndFloorList;
            arr.forEach((ele) => {
                if (item == ele.id) {
                    this.userinfo.floorOptions = ele.floorNameList;
                }
            });
        },
        getClientStatus(page, val) {
            // console.log(this.userinfo.ctmName);
            if (this.userinfo.ctmName) {
                var querys = {
                    name: this.userinfo.ctmName,
                    mobile: this.userinfo.ctmMobile,
                    cadCode: this.userinfo.ctmCode,
                    page: page,
                    size: this.filters.pagination.limit,
                };
                api.request("/skn/getClientConsumeInformation", querys, (res) => {
                    if (res.result == true) {
                        var data = res.data.list;
                        this.ccData = data
                        if (data.length == 0) {
                            // console.log('没有历史数据 初诊');
                            this.userinfo.status = "1";
                        } else if (data.length != 0) {
                            // console.log('有历史数据 复诊');
                            this.userinfo.status = "2";
                        }
                        if (val == 1) {
                            router.push({ name: 'orderList', params: this.userinfo })
                        } else if (val == 2) {
                            router.push({ name: 'consumeList', params: this.userinfo })

                        }
                    }
                }, (res) => { });
            } else {
                if (val == 1) {
                    router.push({ name: 'orderList', params: this.userinfo })
                } else if (val == 2) {
                    router.push({ name: 'consumeList', params: this.userinfo })

                }
            }

        },
        // 划扣
        consume() {
            this.userinfo.infoCode = 1
            this.getClientStatus(1, 2)
            this.getEarId(this.userinfo.earId)
        },
        // 购买
        billing() {
            this.userinfo.infoCode = 0
            this.getClientStatus(1, 1)
            this.getEarId(this.userinfo.earId)
        },
        // 批量删除
        delAll() {
            var data = this.multipleSelection;
            var id = [];
            data.map(function (item, index) {
                console.log(item)
                id.push(item.id);
            });
            this.$confirm("确定要删除选中的数据吗？", "删除项目", {
                center: true,
            })
                .then((res) => {
                    api.requestQuiet(
                        "/skn/deleteProjectMenuAll", {
                            idList: id.toString(),
                        },
                        (res) => {
                            if (res.result == true) {
                                _g.toast("success", "删除成功");
                                this.query(this.filters.pagination.page);
                            } else {
                                _g.toast("error", "删除失败");
                                this.query(this.filters.pagination.page);
                            }
                        }
                    );
                })
                .catch((err) => {
                    // this.$message.error('删除失败！');
                });
        },
        currentChange(currentRow) {
            this.datekey = Date.now()
            // console.log(currentRow);
            if (currentRow) {
                this.userCode = currentRow.ctmCode
                api.request("/customer/findCustomerInfoById", { ctmCode: currentRow.ctmCode }, (res) => {
                    this.userinfo = res.data.info
                    this.userinfo.information = 0
                })
            }

        },
        // 查询数据列表
        query(page) {
            // console.log(this.filters.startTime)
            var querys = {
                ctmCode: this.filters.ctmCode,
                ctmName: this.filters.ctmName,
                ctmMobile: this.filters.ctmMobile,
                startTime: '',
                endTime: '',
                page: page,
                size: this.filters.pagination.limit,
            }
            if (this.filters.startTime) {
                querys.startTime = this.filters.startTime[0]
                querys.endTime = this.filters.startTime[1]
            }
            // console.log(querys)
            api.request('/customer/findCustomerInfoPage', querys, (res) => {
                this.loading = false
                // console.log(res)
                var data = res.data.list
                this.tableData = data
                this.filters.pagination.total = parseInt(res.data.count)
                // 首次进入默认第一条数据
                if (page == 1 && this.tableData.length != 0) {
                    this.datekey = Date.now()
                    this.userCode = this.tableData[0].ctmCode
                    api.request("/customer/findCustomerInfoById", { ctmCode: this.tableData[0].ctmCode }, (res) => {
                        this.userinfo = res.data.info
                    })
                    this.$nextTick(() => {
                        this.$refs.table.setCurrentRow(this.tableData[0]);
                    })
                }

            })
        },
    },


}
</script>
<style scoped>
@import "../../../assets/css/main.css";
.customer >>> .el-form-item__content {
  line-height: 40px !important;
}

.left {
  width: 30%;
  /* border: 1px solid red; */
  box-shadow: 0px 2px 7px 2px #ebeef5;
}
.page-right {
  width: 70%;
}
.all {
  display: flex;
}
.customer >>> .el-button i {
  margin-right: 0px !important;
}
.layout-page-box >>> .el-form-item__label {
  line-height: 40px !important;
}
</style>
